import React from 'react'
import { connect } from 'react-redux'
import { NavigateFunction, useNavigate } from 'react-router-dom'

import { bindActionCreators } from 'redux'
import { reduxForm } from 'redux-form/immutable'

import { getDisplayDate } from '@lyrahealth-inc/shared-app-logic/src/features/common/utils/dateUtils'
import NavButton from '@lyrahealth-inc/ui-core/lib/atoms/buttons/navButton/NavButton'

import AccountType from './accountType/AccountType'
import * as registerProviderActions from './data/registerProviderActions'
import styles from './registerProvider.module.scss'
import ProviderInfoForm from '../../common/components/forms/providerInfo/ProviderInfoForm'
import providerInfoValidate from '../../common/components/forms/providerInfo/providerInfoValidate'
import { bannerMessages } from '../../common/constants/appConstants'
import { OUTCOMES_CONSENT } from '../../common/constants/routingConstants'
import { getErrorText } from '../../common/utils/utils'
import * as alertActions from '../../data/alertActions'
import {
  getAuthUserEmail,
  getAuthUserFirstName,
  getAuthUserId,
  getAuthUserLastName,
  getAuthUserOutcomesEnabled,
} from '../../data/auth/authSelectors'
import * as authActions from '../../data/authActions'
import { RootState } from '../../data/store'
import { getProvidersRegisterAccountType } from '../data/providerSelectors'

type RegisterProviderProps = {
  handleSubmit?: (...args: any[]) => any
  submitting?: boolean
  actions?: any
  navigate: NavigateFunction
  accountType?: string
  outcomesEnabled?: boolean
}

class RegisterProvider extends React.Component<RegisterProviderProps> {
  _submitForm = (values: any) => {
    this.props.actions.hideAlerts()

    const formData = new FormData()
    const vals = values.toJS()
    Object.keys(vals).forEach((key) => {
      let val = vals[key]
      if (key === 'date_of_birth') {
        val = getDisplayDate(val, 'YYYY-MM-DD')
      }
      if (['identification_file_front', 'identification_file_back'].includes(key)) {
        val = val[0]
      }
      formData.append(key, val)
    })

    return this.props.actions.submitRegisterProvider(formData).then(
      () => {
        // request successful
        this.props.actions.registerSuccessful()
        if (this.props.outcomesEnabled) {
          // outcomes enabled, redirect to consent view
          this.props.navigate(OUTCOMES_CONSENT.route, { state: { withoutNav: true } })
        } else {
          this.props.navigate('/')
        }

        this.props.actions.addAlert({
          show: true,
          contents: bannerMessages.REGISTER_PROVIDER_SUCCESS,
          style: 'success',
          expires: true,
          autoDismissTimer: 10000,
        })
      },
      (error: any) => {
        const errorText = error.response.data.message || getErrorText(error.response.status)
        this.props.actions.addAlert({
          show: true,
          contents: errorText,
          style: 'danger',
          expires: true,
        })
      },
    )
  }

  render() {
    const { handleSubmit, submitting } = this.props

    if (!this.props.accountType) {
      return <AccountType />
    }

    return (
      <div>
        <div className={styles['back-container']}>
          <NavButton styleType='back' text='Account Type' onClick={() => this.props.actions.clearAccountType()} />
        </div>

        <div className={styles.card}>
          <h2 className={styles.title}>Register Provider</h2>

          <ProviderInfoForm
            handleSubmit={handleSubmit}
            submitFunction={this._submitForm}
            submitting={submitting}
            accountType={this.props.accountType}
            primaryButtonText='Register'
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: RootState) => {
  const accountType = getProvidersRegisterAccountType(state)

  return {
    outcomesEnabled: getAuthUserOutcomesEnabled(state) ?? false,
    accountType: accountType,
    initialValues: {
      lyra_id: getAuthUserId(state),
      account_type: accountType,
      first_name: getAuthUserFirstName(state),
      last_name: getAuthUserLastName(state),
      email: getAuthUserEmail(state),
      payment_preference: '2',
    },
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    actions: bindActionCreators({ ...registerProviderActions, ...alertActions, ...authActions }, dispatch),
  }
}

const ConnectedRegisterProvider = connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  reduxForm({
    form: 'ProviderInfoForm',
    validate: providerInfoValidate,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    touchOnBlur: false,
    // @ts-expect-error TS(2345): Argument of type 'typeof RegisterProvider' is not ... Remove this comment to see the full error message
  })(RegisterProvider),
) as React.ComponentType<{ navigate: NavigateFunction }>

export default function RegisterProviderWithRouter() {
  const navigate = useNavigate()
  return <ConnectedRegisterProvider navigate={navigate} />
}
